<template>
  <div>
    <section class="champ-cinema mt-4 mb-0" id="champ-cinema">
      <b-container>
        <b-row>
          <b-col cols="12" md="6" class="mb-2" v-if="portalConfig.text.topPickVideos !== null">
            <h4 class="section-title d-inline-block">{{ portalConfig.text.topPickVideos }}</h4>
          </b-col>
        </b-row>
        <GetData :endpoint='"articles/" + portalConfig.portalName + videoEndpoint + count + page' :key="componentKeyTPV">
          <FrogVideoCard
            :cols="12" :md="4" :lg="4"
            :cardType="portalConfig.themeLayout.id"
            slot-scope="{ response: videos }"
            :result="videos.results"
            :portalName="portalConfig.portalName"
            :pagination="true"
            :prevData="videos.previousCursor"
            :nextData="videos.nextCursor"
            @nextVideoPage="nextVideoPage(videos.nextCursor)"
            @previousVideoPage="prevVideoPage(videos.previousCursor)"
          />
        </GetData>
      </b-container>
    </section>
  </div>
</template>

<script>
import GetData from '@/services/GetData'
import FrogVideoCard from '@/components/FrogVideoCard'
import { mapGetters } from 'vuex'

const breakpoints = {
  sm: 540,
  md: 720,
  lg: 960
}

export default {
  name: 'SectionVideosChampCinema',
  props: {
    result: Array,
    breakpoints: Object,
    videoEndpoint: String
  },
  components: {
    GetData,
    FrogVideoCard
  },
  data: () => {
    return {
      componentKeyTPV: 0,
      page: '',
      count: ''
    }
  },
  computed: {
    ...mapGetters({
      portalConfig: 'getPortalConfig'
    })
  },
  created () {
    window.addEventListener('resize', this.resizeHandler)
    this.resizeHandler()
  },
  methods: {
    forceRerender () {
      this.componentKeyTPV += 1
    },
    nextVideoPage (next) {
      this.componentKeyTPV++
      this.page = '&next=' + next
    },
    prevVideoPage (prev) {
      this.componentKeyTPV++
      this.page = '&previous=' + prev
    },
    resizeHandler (e) {
      const clientWidth = window.innerWidth
      if (clientWidth < breakpoints.md) {
        this.count = '?count=1'
      } else {
        this.count = '?count6'
      }
    }
  }
}
</script>
